import React from 'react';
import { useNavigate } from 'react-router-dom';
import './error-pages.scss';

const ServerErrorPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="error-page">
      <div className="error-page__card">
        <div className="error-page__brand">RealityCoach</div>

        <div className="error-page__code error-page__code--red">500</div>

        <h1 className="error-page__title">Internal Server Error</h1>

        <p className="error-page__description">
          Something went wrong on our end. Our team has been notified and we're
          working to resolve the issue. Please try again in a moment.
        </p>

        <div className="error-page__actions">
          <button className="error-page__btn-primary" onClick={() => window.location.reload()}>
            Try Again
          </button>
          <button className="error-page__btn-secondary" onClick={() => navigate('/')}>
            Go to Dashboard
          </button>
        </div>

        <div className="error-page__info-box error-page__info-box--error">
          <p>
            If this problem persists, please contact your administrator or
            refresh the page to try again.
          </p>
        </div>

        <p className="error-page__footer">Error code: 500 - Internal Server Error</p>
      </div>
    </div>
  );
};

export default ServerErrorPage;
